import { GSQuickFilter } from "golfstatus_react_components";
import React, { useState } from "react";
import "./course-quick-filter.scss";
import CourseLineItem from "./course-line-item";
import { useEffect } from "react";
import { useCallback } from "react";

const CourseQuickFilter = (props) => {
  const { availableTeesOnly, selectedTees, setSelectedTees } = props;
  const [courseName] = useState("");

  const selectCourse = useCallback(
    (course) => {
      props?.inputTouched?.();
      props?.selectCourse?.(course);
    },
    [props]
  );

  const removeCourse = (course) => {
    props?.removeCourse?.(course);
  };

  const getFilteredCourses = useCallback(() => {
    const filteredCourses = props.selectedFacility?.courses
      ?.filter?.((c) => c.active && c.name.includes?.(courseName))
      ?.map?.((c) => ({
        id: props.selectedCourses?.length,
        scorecardPosition: (props.selectedCourses ?? [])?.length + 1,
        numberOfHoles: c.numberOfHoles,
        holesToPlay: "all_holes",
        course: { ...c },
      }));
      return filteredCourses
  }, [courseName, props.selectedFacility?.courses, props.selectedCourses]);

  useEffect(() => {
    if (
      props.selectedCourses.length === 0 &&
      getFilteredCourses()?.length === 1 &&
      courseName === ""
    ) {
      selectCourse(getFilteredCourses()?.[0]);
    }
  }, [
    getFilteredCourses,
    courseName,
    props.selectedCourses.length,
    selectCourse,
  ]);

  const teeSelected = (courseID, tee) => {
    props?.teeSelected?.(courseID, tee);
  };

  const teeRemoved = (courseID, tee) => {
    props?.teeRemoved?.(courseID, tee);
  };

  const holesSelected = (courseID, holes) => {
    props?.holesSelected?.(courseID, holes);
  };

  const setSelectedCourseTees = useCallback(
    (tees, courseID) => {
      const courseTees = selectedTees
        ?.filter?.((t) => t.courseID === courseID).map?.(t => t.id)
        ?.join?.("");
      const nonCourseTees = selectedTees?.filter?.(
        (t) => t.courseID !== courseID
      );
      const ts = tees?.map?.(t => t.id)?.join?.("");
      if (courseTees !== ts) {
        setSelectedTees?.([...nonCourseTees, ...tees]);
      }
    },
    [setSelectedTees, selectedTees]
  );

  return (
    <course-quick-filter>
      <GSQuickFilter
        itemSelected={selectCourse}
        filteredList={getFilteredCourses()}
        selectedList={props.selectedCourses}
        emptySelectedList="Select a course from the list below."
        itemRemoved={removeCourse}
        getItem={(roundCourse) => (
          <CourseLineItem
            teeSelected={teeSelected}
            teeRemoved={teeRemoved}
            holesSelected={holesSelected}
            enableHoleSelect={props.selectedCourses?.includes?.(roundCourse)}
            enableTeeSelect={props.selectedCourses?.includes?.(roundCourse)}
            selectedTees={props.selectedTees?.filter?.(
              (rc) => rc.courseID === roundCourse.id
            )}
            setSelectedTees={setSelectedCourseTees}
            {...roundCourse}
            availableTeesOnly={availableTeesOnly}
          />
        )}
        multiple={true}
        selectListType="grey-empty-list rounded-empty-list small-gap search-list"
      />
    </course-quick-filter>
  );
};

export default CourseQuickFilter;
